module.exports = __webpack_public_path__ + "static/media/indeed.15171bd7.svg";